import { useCallback, useMemo, useState } from "react";
import { DEFAULT_FILTERS, filterShips, filtersActive, yearBounds, needsWork } from "../helpers/shipFilters";

// Holds the map filters (type, year range, photos, needs work) and the filtered list of ships.
// Search, the "latest ships" lists and the leaderboard keep using the full list.
export default function useShipFilters(ships) {
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [timelineOpen, setTimelineOpen] = useState(false);

  const bounds = useMemo(() => yearBounds(ships), [ships]);
  const visible = useMemo(() => filterShips(ships, filters), [ships, filters]);
  const active = filtersActive(filters);

  const stats = useMemo(() => {
    let needs = 0;
    let undated = 0;
    for (const s of ships) {
      if (needsWork(s)) needs++;
      if (!s.date) undated++;
    }
    return { needsWork: needs, undated };
  }, [ships]);

  const patch = useCallback((changes) => setFilters((f) => ({ ...f, ...changes })), []);
  const reset = useCallback(() => setFilters(DEFAULT_FILTERS), []);

  const toggleType = useCallback(
    (id) => setFilters((f) => ({ ...f, types: f.types.includes(id) ? f.types.filter((t) => t !== id) : [...f.types, id] })),
    []
  );

  // The slider reports its handles; a handle sitting on the limit means "open ended" (null).
  const setRange = useCallback(
    (from, to) => {
      if (!bounds) return;
      setFilters((f) => ({ ...f, from: from <= bounds.min ? null : from, to: to >= bounds.max ? null : to }));
    },
    [bounds]
  );

  return {
    filters, patch, reset, toggleType, setRange,
    visible, active, bounds, stats,
    filtersOpen, setFiltersOpen, timelineOpen, setTimelineOpen,
  };
}
